import $ from 'jquery';
import Backbone from 'backbone';
import i18n, { t }  from '../../i18n/i18n.js';
import View from '../../../controls/View.js';
import MessagePopupView from '../../../controls/MessagePopupView.js';
import MainTabbedArea from '../../views/MainTabbedArea.js';
import app from '../../App.js';

import Vue from 'vue';
import CampaignEditTemplate from './CampaignEditTemplate.vue';
import CampaignUploadRecording from './VoiceBroadcastSettings.vue';

var template = '<table class="edit-table"><tbody>' +
    '<tr><th><label for="edit_campaign_name">{campaign_edit.basic.campaign_name}</label></th><td><input type="text" data-name="campaign_name" id="edit_campaign_name" /></td></tr>' +
    '<tr><th><label for="edit_campaign_external_id">{campaign_edit.basic.campaign_external_id}</label></th><td><input type="text" data-name="campaign_external_id" id="edit_campaign_external_id" /></td></tr>' +
    '<tr><th><label for="edit_campaign_description">{campaign_edit.basic.campaign_description}</label></th><td><textarea data-name="campaign_description" id="edit_campaign_description" /></td></tr>' +
    '<tr><th><label for="edit_campaign_status">{campaign_edit.basic.campaign_status}</label></th><td><select data-name="campaign_status" id="edit_campaign_status"></select></td></tr>' +
    '<tr><th><label for="edit_campaign_mode">{campaign_edit.basic.campaign_mode}</label></th><td><select data-name="campaign_mode" id="edit_campaign_mode"></select></td></tr>' +
    '<tr><th><label for="edit_campaign_priority">{campaign_edit.basic.campaign_priority}</label></th><td><input type="number" step="1" data-name="campaign_priority" id="edit_campaign_priority" value="1000" /></td></tr>' +
    '<tr><th><label for="edit_campaign_exclusive">{campaign_edit.basic.campaign_exclusive}</label></th><td><input type="checkbox" data-name="campaign_exclusive" id="edit_campaign_exclusive" value="1" /></td></tr>' +
    '</tbody></table><div id="vue-upload-recording"/><div id="vue-edit-template"/>';

const CampaignEditBasicPage = View.extend({

    events: {
        'change input,select,textarea': 'onFieldChange'
    },

    initialize: function (options) {
        var that = this;

        that.options = options = options || {};

        var $cornerButtons = that.$cornerButtons = $('<div class="corner-buttons">').appendTo(that.$el);

        if (options.campaignId) {
            $('<button class="duplicate-button">').text(t('campaign_edit.basic.duplicate')).click(that.duplicateClicked.bind(that)).appendTo($cornerButtons);
        }
        $('<a class="add-button">').text(t('campaign_edit.basic.new')).attr('href', '/admin/management/projects/' + options.projectId + '/campaigns/new').appendTo($cornerButtons);

        var $scrollPane = that.$scrollPane = $('<div class="scrollable-pane-content">').appendTo($('<div class="scrollable-pane">').appendTo(that.$el));

        $('<h2>').text(t('campaign_edit.basic.title')).appendTo($scrollPane);

        var $table = that.$table = $(i18n.processLocalizedString(template)).appendTo($scrollPane);
        $table.find('input[data-name=campaign_priority]').numeric({ decimal: false });

        $table.find('select[data-name=campaign_status]').append(
            $('<option>').text(t('campaign_status.active')).val('active'),
            $('<option>').text(t('campaign_status.inactive')).val('inactive'),
            $('<option>').text(t('campaign_status.returns_only')).val('returns_only'),
            $('<option>').text(t('campaign_status.new_only')).val('new_only')
        );

        $table.find('select[data-name=campaign_mode]').append(
            $('<option>').text(t('campaign_mode.outgoing')).val('outgoing'),
            $('<option>').text(t('campaign_mode.incoming')).val('incoming'),
            $('<option>').text(t('campaign_mode.outgoing_incoming')).val('outgoing_incoming'),
            $('<option>').text(t('campaign_mode.voice_broadcast')).val('voice_broadcast')
        ).change(function () {
            that.editTemplateVue.$data.campaignMode = $(this).val();
            that.VoiceBroadcastSettings.$data.campaignMode = $(this).val();
        });

        $('<div class="corner-commit-actions">').append(
            $('<button class="action-save-button">').text(t('save')).click(that.saveClicked.bind(that))
        ).appendTo(that.$el);

        if (options.campaignId) {
            app.AlertUI.showLoader();
            that.ajaxGet(app.apiUrl('campaigns/' + encodeURIComponent(options.campaignId)), { 'fields': 'id,external_id,project_id,status,mode,priority,name,description,exclusive,tts_template,broadcast_settings' })
                .always(function () {
                    app.AlertUI.hideLoader();
                })
                .then(function (data) {
                    that._campaignData = data;
                    that.options.projectId = data['project_id'];

                    if (app.getMainView() instanceof MainTabbedArea) {
                        app.getMainView().refreshTitleArea();
                    }

                    that.$table.find('input[data-name=campaign_name]').val(data['name']);
                    that.$table.find('input[data-name=campaign_external_id]').val(data['external_id']);
                    that.$table.find('textarea[data-name=campaign_description]').val(data['description']);
                    that.$table.find('select[data-name=campaign_status]').val(data['status']);
                    that.$table.find('select[data-name=campaign_mode]').val(data['mode']);
                    that.$table.find('input[data-name=campaign_priority]').val(i18n.displayNumber(data['priority']));
                    that.$table.find('input[data-name=campaign_exclusive]').prop('checked', data['exclusive']);

                    that.initVue();
                    that.initVue2()
                })
                .fail(function (xhr, error) {
                    app.showXhrError(xhr, error);
                });
        } else {
            setTimeout(() => that.initVue(), 0);
            setTimeout(() => that.initVue2(), 0);
        }
    },

    initVue: function() {
        const editTemplateVue = this.editTemplateVue = new (Vue.extend(CampaignEditTemplate))({
            data: {
                templateString: this._campaignData && this._campaignData['tts_template'] || '',
                campaignId: this._campaignData && this._campaignData['id'],
                campaignMode: this._campaignData && this._campaignData['mode'],
            },
        });

        editTemplateVue.$mount('#vue-edit-template');

        $(editTemplateVue.$el).show();
    },

    initVue2: function() {
        const VoiceBroadcastSettings = this.VoiceBroadcastSettings = new (Vue.extend(CampaignUploadRecording))({
            data: {
                campaignMode: this._campaignData && this._campaignData['mode'],
                projectId: this.options && this.options.projectId,
                campaignId: this._campaignData && this._campaignData['id'],

            },
        });

        if (this._campaignData && this._campaignData['broadcast_settings']) {
            const settings = JSON.parse(this._campaignData['broadcast_settings']);

            Object.entries(settings).forEach(([key, value]) => {

                VoiceBroadcastSettings.$data[key] = value;
            })
        }

        VoiceBroadcastSettings.$mount('#vue-upload-recording');

        $(VoiceBroadcastSettings.$el).show();
    },

    hasTitleAreaVisible: true,
    titleAreaContent: function () {
        return [
            $('<h2 class="title">').text(this._campaignData ? this._campaignData['name'] : '...'),
            this.options.campaignId ? $('<a class="back">').text('< ' + t('campaign_edit.back')).attr('href', '/admin/management/projects/' + this.options.projectId + '/campaigns') : null
        ];
    },

    render: function () {

        return this;
    },

    saveClicked: function () {
        var that = this;

        that.$table.find('input.invalid,textarea.invalid,select.invalid').removeClass('invalid');

        var $name = that.$table.find('input[data-name=campaign_name]');
        var $externalId = that.$table.find('input[data-name=campaign_external_id]');
        var $description = that.$table.find('textarea[data-name=campaign_description]');
        var $status = that.$table.find('select[data-name=campaign_status]');
        var $mode = that.$table.find('select[data-name=campaign_mode]');
        var $priority = that.$table.find('input[data-name=campaign_priority]');
        var $exclusive = that.$table.find('input[data-name=campaign_exclusive]');
        var $ttsTemplate = that.editTemplateVue.$data.templateString;
        var $broadcastSettings = that.VoiceBroadcastSettings.save;

        var invalid = false;

        var data = {
            'project_id': that.options.projectId,
            'name': $name.val().trim(),
            'external_id': $externalId.val().trim(),
            'description': $description.val().trim(),
            'status': $status.val(),
            'mode': $mode.val(),
            'priority': i18n.parseNumber($priority.val()),
            'exclusive': $exclusive.prop('checked'),
            'tts_template': $ttsTemplate,
            'broadcast_settings': $broadcastSettings,
        };


        if (!data.name) {
            invalid = true;
            $name.addClass('invalid');
        }

        if (invalid) {
            that.$table.find('input.invalid,textarea.invalid,select.invalid').first().focus();
            return;
        }

        var apiUrl;
        if (that.options.campaignId) {
            apiUrl = app.apiUrl('campaigns/' + encodeURIComponent(that.options.campaignId));
        } else {
            apiUrl = app.apiUrl('campaigns');
        }

        app.AlertUI.showLoader(t('activity_indicator.saving'));

        that.ajaxJsonPost(apiUrl, data)
            .always(function () {
                app.AlertUI.hideLoader();
            })
            .then(function (response) {
                that._saveNeeded = false;

                new MessagePopupView({addClass: 'done', message: t('campaign_edit.basic.saved_prompt'), queue: true}).show();

                if (!that.options.campaignId) {
                    that.options.campaignId = that.editTemplateVue.$data.campaignId = response['id'];

                    $('<button class="duplicate-button">').text(t('campaign_edit.basic.duplicate')).click(that.duplicateClicked.bind(that)).prependTo(that.$cornerButtons);

                    that._campaignData = data;
                    Backbone.history.navigate('/management/projects/' + that.options.projectId + '/campaigns/' + that.options.campaignId + '/basic', { trigger: false, replace: true });

                    if (app.getMainView() instanceof MainTabbedArea) {
                        app.getMainView().refreshTitleArea();
                    }
                }
            })
            .fail(function (xhr, error) {
                app.showXhrError(xhr, error);
            });

        return that;
    },

    onFieldChange: function () {
        this._saveNeeded = true;
        return this;
    },

    duplicateClicked: function () {
        var that = this;

        var duplicate = function () {

            var apiUrl = app.apiUrl('campaigns/' + encodeURIComponent(that.options.campaignId) + '/duplicate');

            app.AlertUI.showLoader(t('activity_indicator.saving'));

            that.ajaxPost(apiUrl)
                .always(function () {
                    app.AlertUI.hideLoader();
                })
                .then(function (response) {
                    Backbone.history.navigate('/management/projects/' + that.options.projectId + '/campaigns/' + response['id'] + '/basic', { trigger: true });
                })
                .fail(function (xhr, error) {
                    app.showXhrError(xhr, error);
                });

        };

        if (that._saveNeeded) {
            app.AlertUI.confirmNegative(t('generic_prompts.confirm_leave_unsaved'), null, duplicate);
        } else {
            duplicate();
        }

        return that;
    },

    hasUnsavedChanges: function() {
        return this._saveNeeded;
    },

});

export default CampaignEditBasicPage
